import React from "react";
import { Hourglass } from "lucide-react";
import Emblem from "@/components/Emblem";
import { useAuth } from "@/context/AuthContext";

export default function Pending() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen relative flex items-center justify-center bg-[var(--rsp-bg)] px-6 overflow-hidden">
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1625763689436-ff2665557e09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--rsp-bg)]/70 via-[var(--rsp-bg)]/85 to-[var(--rsp-bg)]" />
      <div className="relative z-10 max-w-md w-full text-center rsp-card p-8 fade-up" data-testid="pending-card">
        <div className="flex justify-center mb-5"><Emblem size={96} /></div>
        <div className="inline-flex items-center gap-2 pill mb-4">
          <Hourglass size={15} /> Awaiting Approval
        </div>
        <h1 className="heading text-4xl mb-2">Stand By, {user?.name?.split(" ")[0] || "Recruit"}</h1>
        <p className="text-[var(--rsp-gray)] leading-relaxed">
          Your access request has been received. An RSP Riverside administrator must approve your account before you
          can enter. Check back shortly.
        </p>
        <div className="mt-6 text-sm font-mono-rsp text-[var(--rsp-muted)]" data-testid="pending-email">{user?.email}</div>
        <button data-testid="pending-signout" onClick={logout}
          className="mt-6 text-[var(--rsp-gray)] hover:text-[var(--rsp-cream)]">Sign out</button>
      </div>
    </div>
  );
}
